
import Vue from 'vue';
import {shopsStore} from '~/lib/accessors/store-accessor';
import {ShopCategory} from '~/lib/api/types/ShopCategory';


export default Vue.extend({
  data() {
    return {
      selectedCategoryId: -1,
      allCategory: {
        id: -1,
        name: 'Wszystkie'
      } as ShopCategory
    }
  },
  computed: {
    categories(): ShopCategory[] {
      return [this.allCategory].concat(shopsStore.categories)
    },
  },
  mounted() {
    this.$emit('resize');
  },
  methods: {
    selectCategory(category: ShopCategory) {
      this.selectedCategoryId = category.id;
      if(category.id === -1) {
        this.$emit('selectCategory', null);
      } else {
        this.$emit('selectCategory', category);
      }
    }
  },
  watch: {
    categories() {
      this.$emit('resize');
    }
  }
})
